import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w100 lskyblueBg" }
const _hoisted_2 = {
  class: "w100",
  style: {"padding-top":"108px"}
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "w100 posRe"
}
const _hoisted_5 = {
  key: 0,
  class: "w100 mt40",
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "w100 posRe AvailableTimeContent" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 0,
  class: "AvailableTimeContent"
}
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { key: 5 }
const _hoisted_13 = {
  class: "w30 fl ofh",
  style: {"min-width":"300px","height":"calc(100vh - 110px)"}
}
const _hoisted_14 = {
  class: /*#__PURE__*/_normalizeClass(`w70 fl ofh`),
  style: {"height":"calc(100vh - 110px)"}
}
const _hoisted_15 = {
  class: "pad10 with_white_bg",
  style: {"height":"200px"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("p", {
    class: "fs24 kakugo centered fw600",
    style: {"color":"#696969"}
  }, "確認")
], -1)
const _hoisted_18 = {
  class: "text mc",
  style: {"padding":"20px","color":"#696969","width":"480px"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "warningText fs12 kakugo centered" }, "日程調整を確定できるユーザーを選択してください。", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_LinkHeaderRoomSettings = _resolveComponent("LinkHeaderRoomSettings")!
  const _component_EditableZoomSettings = _resolveComponent("EditableZoomSettings")!
  const _component_InstantRoomContent = _resolveComponent("InstantRoomContent")!
  const _component_EditableScheduleView = _resolveComponent("EditableScheduleView")!
  const _component_MailPreview = _resolveComponent("MailPreview")!
  const _component_FormSettings = _resolveComponent("FormSettings")!
  const _component_PublicSettings = _resolveComponent("PublicSettings")!
  const _component_ParentSettings = _resolveComponent("ParentSettings")!
  const _component_AppointmentCardViewSmall = _resolveComponent("AppointmentCardViewSmall")!
  const _component_ConnectedCalendar = _resolveComponent("ConnectedCalendar")!
  const _component_WeeklyDetailSchedule = _resolveComponent("WeeklyDetailSchedule")!
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_FixTypeButtons = _resolveComponent("FixTypeButtons")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!
  const _component_GoAvailableScheduleModal = _resolveComponent("GoAvailableScheduleModal")!
  const _component_LeftNavPanel = _resolveComponent("LeftNavPanel")!
  const _component_LeftRoomSettingsTotalMenu = _resolveComponent("LeftRoomSettingsTotalMenu")!
  const _component_OptionModal = _resolveComponent("OptionModal")!
  const _component_ConfirmChangeOwnerModal = _resolveComponent("ConfirmChangeOwnerModal")!
  const _component_InputAstagNameModal = _resolveComponent("InputAstagNameModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createVNode(_component_LinkHeaderRoomSettings, {
      ref: "Header",
      pageTitle: `調整ページを作成`,
      buttonTitle: _ctx.action == `edit` ? `更新` : `作成`,
      onClickPinkButton: _ctx.publishRoom,
      onSaveDraft: _ctx.saveDraft,
      showBackButton: true,
      onShowRoomPreview: _ctx.showRoomPreview,
      onSelect: _ctx.selectTab,
      onChangeRoomType: _ctx.changeRoomType,
      clickChangeName: _ctx.clickChangeName,
      clickChangeAutoMode: _ctx.clickChangeAutoMode,
      editEditableContent: _ctx.editEditableContent
    }, null, 8, ["buttonTitle", "onClickPinkButton", "onSaveDraft", "onShowRoomPreview", "onSelect", "onChangeRoomType", "clickChangeName", "clickChangeAutoMode", "editEditableContent"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.selectedTabName == `room`)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            (_ctx.rcm.room_setting)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.rcm.room_setting.is_instant_room)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (_ctx.showZoomSettings)
                          ? (_openBlock(), _createBlock(_component_EditableZoomSettings, { key: 0 }))
                          : _createCommentVNode("", true),
                        _createVNode(_component_InstantRoomContent, {
                          style: {"max-width":"700px"},
                          onClickInstantButton: _ctx.clickInstantButton,
                          isEdit: true
                        }, null, 8, ["onClickInstantButton"])
                      ]))
                    : (_openBlock(), _createBlock(_component_EditableScheduleView, {
                        key: 1,
                        editEditableContent: _ctx.editEditableContent,
                        closePanel: _ctx.closePanel
                      }, null, 8, ["editEditableContent", "closePanel"]))
                ]))
              : _createCommentVNode("", true)
          ]))
        : (_ctx.selectedTabName == `mail`)
          ? (_openBlock(), _createElementBlock("section", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_MailPreview, { editEditableContent: _ctx.editEditableContent }, null, 8, ["editEditableContent"])
              ])
            ]))
          : (_ctx.selectedTabName == `form`)
            ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                (_ctx.rcm.room)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(_component_FormSettings, {
                        onEditField: _ctx.editField,
                        onAddNewField: _ctx.addNewField,
                        editEditableContent: _ctx.editEditableContent
                      }, null, 8, ["onEditField", "onAddNewField", "editEditableContent"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : (_ctx.selectedTabName == `public_settings`)
              ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
                  _createVNode(_component_PublicSettings, {
                    class: "AvailableTimeContent",
                    closePanel: _ctx.closePanel,
                    ref: "PublicSettings",
                    onClickUseNoindex: _ctx.clickUseNoindex,
                    onClickFixType: _ctx.clickFixType,
                    onSelectTimingType: _ctx.selectTimingType,
                    onSelectDisplayScheduleType: _ctx.selectDisplayScheduleType,
                    onSelectShowVoteType: _ctx.selectShowVoteType,
                    onSelectShowFilterVoteType: _ctx.selectShowFilterVoteType,
                    onInputPageKey: _ctx.inputPageKey,
                    onSaveRule: _ctx.saveRule,
                    editEditableContent: _ctx.editEditableContent
                  }, null, 8, ["closePanel", "onClickUseNoindex", "onClickFixType", "onSelectTimingType", "onSelectDisplayScheduleType", "onSelectShowVoteType", "onSelectShowFilterVoteType", "onInputPageKey", "onSaveRule", "editEditableContent"])
                ]))
              : (_ctx.selectedTabName == `parent_settings`)
                ? (_openBlock(), _createElementBlock("section", _hoisted_11, [
                    _createVNode(_component_ParentSettings, {
                      class: "AvailableTimeContent",
                      closePanel: _ctx.closePanel,
                      editEditableContent: _ctx.editEditableContent,
                      ref: "ParentSettings",
                      onFixBy: _ctx.fixBy
                    }, null, 8, ["closePanel", "editEditableContent", "onFixBy"])
                  ]))
                : (_ctx.selectedTabName == `asview`)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        (false && _ctx.cm.createType == `vote`)
                          ? (_openBlock(), _createBlock(_component_AppointmentCardViewSmall, {
                              key: 0,
                              editEditableContent: _ctx.editEditableContent
                            }, null, 8, ["editEditableContent"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ConnectedCalendar)
                      ]),
                      _createElementVNode("section", _hoisted_14, [
                        _createVNode(_component_WeeklyDetailSchedule, { ref: "WeeklyDetailSchedule" }, null, 512)
                      ])
                    ]))
                  : _createCommentVNode("", true)
    ]),
    _createVNode(_component_VueFinalModal, {
      "modal-id": "SelectFixUserModal",
      "content-class": "ofs modalContent shadowContent rad10 pad15 modalStandard"
    }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_md_progress_bar, {
              key: 0,
              "md-mode": "indeterminate",
              class: "modalStandard modalTopProgressBar",
              style: {"margin-top":"-20px"}
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_component_FixTypeButtons, {
              appo: _ctx.rcm.appo,
              onFixBy: _ctx.fixBy
            }, null, 8, ["appo", "onFixBy"])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_GoAvailableScheduleModal),
    _createVNode(_component_LeftNavPanel, {
      ref: "leftPanel",
      panelType: _ctx.panelType,
      linkCal: _ctx.linkCal,
      editingField: _ctx.editingField,
      onAddField: _ctx.addField,
      onClosePanel: _ctx.closePanel
    }, null, 8, ["panelType", "linkCal", "editingField", "onAddField", "onClosePanel"]),
    _createVNode(_component_LeftRoomSettingsTotalMenu, {
      editEditableContent: _ctx.editEditableContent,
      selectedTabName: _ctx.selectedTabName,
      selectTab: _ctx.selectTab,
      clickNewAstag: _ctx.clickNewAstag
    }, null, 8, ["editEditableContent", "selectedTabName", "selectTab", "clickNewAstag"]),
    _createVNode(_component_OptionModal, {
      ref: "OptionModal",
      eventName: `${_ctx.rm.showPlanOptionModalWithName} 課金リクエスト`,
      onClickOK: _ctx.clickOK,
      onClickCancel: _ctx.clickCancel,
      onCloseModal: _ctx.closeOptionModal
    }, null, 8, ["eventName", "onClickOK", "onClickCancel", "onCloseModal"]),
    _createVNode(_component_ConfirmChangeOwnerModal, {
      onClickOK: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeOwnerAndUpdate(true))),
      onClickCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeOwnerAndUpdate(false)))
    }),
    _createVNode(_component_InputAstagNameModal, {
      createType: `normal`,
      willCreateNewAstag: _ctx.willCreateNewAstag,
      onCreateNew: _ctx.createNewAstag
    }, null, 8, ["willCreateNewAstag", "onCreateNew"])
  ]))
}